import gsap from 'gsap';

const initOppsFilter = (section) => {
    const filterButtons = section.querySelectorAll('.js-filter-button');
    const filterReset = section.querySelector('.js-filter-reset');
    const fromHaveringToggle = section.querySelector('.js-from-havering');
    const cards = section.querySelectorAll('.js-card');
    const cardContainer = section.querySelectorAll('.js-card-container');
    const noResults = section.querySelector('.js-no-results');
    const activeClass = 'is-active';

    let showOnlyHavering = false;

    const resetFilter = () => {
        showOnlyHavering = false;
        if(fromHaveringToggle) {
            fromHaveringToggle.classList.remove(activeClass);
        }
        filterReset.classList.add(activeClass);
        filterButtons.forEach(button => {
            button.classList.remove(activeClass);
        })

        gsap.to(cardContainer, {
            opacity: 0,
            onComplete: () => {
                cards.forEach(card => {
                    card.classList.add(activeClass);
                });
                noResults.classList.remove(activeClass);
                gsap.to(cardContainer, {
                    opacity: 1
                })
            }
        })
    }

    const handleFilter = () => {
        let filterTerm = false;
        let showOnlyHavering = false;
        let hasResults = false;

        filterButtons.forEach(button => {
            if (button.classList.contains(activeClass)) {
                filterTerm = button.dataset.category;
            }
        })

        if (fromHaveringToggle && fromHaveringToggle.classList.contains(activeClass)) {
            showOnlyHavering = true;
        }

        gsap.to(cardContainer, {
            opacity: 0,
            onComplete: () => {
                cards.forEach((card) => {
                    const cardFromHavering = Boolean(card.dataset.from);
                    const matchedFilterTerm = filterTerm && card.dataset.tags.includes(filterTerm);

                    const isActive = (showOnlyHavering ? cardFromHavering : true) && (filterTerm ? matchedFilterTerm : true);

                    if(isActive) {
                        hasResults = true;
                    }

                    card.classList.toggle(activeClass, isActive);
                });
                
                noResults.classList.toggle(activeClass, !hasResults);

                gsap.to(cardContainer, { opacity: 1 });
            },
        });

    }

    filterButtons.forEach(button => {
        button.addEventListener('click', () => {
            if (!button.classList.contains(activeClass)) {
                filterReset.classList.remove(activeClass);
                filterButtons.forEach(button => {
                    button.classList.remove(activeClass);
                })
                button.classList.add(activeClass);
                handleFilter();
            } else {
                filterReset.classList.add(activeClass);
                filterButtons.forEach(button => {
                    button.classList.remove(activeClass);
                    resetFilter();
                })
            }
        })
    })

    filterReset.addEventListener('click', () => {
        resetFilter();
    })

    if(fromHaveringToggle) {
        fromHaveringToggle.addEventListener('click', () => {
            showOnlyHavering = !showOnlyHavering;
            if (showOnlyHavering) {
                fromHaveringToggle.classList.add(activeClass);
            } else {
                fromHaveringToggle.classList.remove(activeClass);
            }
            handleFilter();
        })
    }
    
}

export default initOppsFilter;